import React from 'react'

import {Box} from '@vio/atlas/helpers/Box'
import {Text} from '@vio/atlas/Text'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {DestinationPickerNoResultsWrapper} from './styles'
import {Props} from './SuggestionsList'

export const NoResults = ({listType}: Pick<Props, 'listType'>) => {
  return (
    <DestinationPickerNoResultsWrapper listType={listType}>
      <Box paddingBottom="s500" paddingTop="s500">
        <Text variant={listType === 'popover' ? 'titleM' : 'titleL'}>
          <FormattedMessageWrapper
            id="selectorList.noResultsTitle"
            defaultMessage="No results found"
          />
        </Text>
      </Box>
      <Box paddingBottom="s500">
        <Text
          align="center"
          variant={listType === 'popover' ? 'bodyS' : 'bodyM'}
        >
          <FormattedMessageWrapper
            id="suggestionList.noResultsDescription"
            defaultMessage="We couldn’t find any matches."
          />
          <br />
          <FormattedMessageWrapper
            id="suggestionList.noResultsHint"
            defaultMessage="Try using fewer keywords."
          />
        </Text>
      </Box>
    </DestinationPickerNoResultsWrapper>
  )
}
